import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Alert, Button } from '@gsa/afp-component-library';

const Notification = ({ message, id = '', variant = 'success' }) => {
  const [closed, setClosed] = useState(false);

  useEffect(() => {
    setClosed(false);
  }, [id, message, variant]);

  if (closed) {
    return null;
  }

  return (
    <Alert
      key={id}
      slim
      type={variant}
      data-testid="usa-alert-slim"
      // Alert only renders its own close button for types other than error and
      // warning, so the button is supplied here to keep every variant closeable.
      actions={
        <div className="position-absolute right-0 top-0">
          <Button
            aria-label="close"
            data-testid="notification-close-btn"
            variant="unstyled"
            style={{ color: 'black' }}
            className="margin-x-1"
            onClick={() => setClosed(true)}
            leftIcon={{
              name: 'close',
              className: 'usa-icon--size-3',
            }}
          />
        </div>
      }
    >
      {message}
    </Alert>
  );
};

Notification.propTypes = {
  message: PropTypes.node.isRequired,
  variant: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default Notification;
